module.exports = "<br/>\n<br/>\n<br/>\n<br/>\n<br/>\n<div class=\"row\">\n  <div class=\"col-2\"></div>\n  <div class=\"col-8\">\n    <div *ngFor=\"let item of job_list\">\n      <app-job-adv [job_adv]=\"item\"></app-job-adv>\n    </div>\n  </div>\n  <div class=\"col-2\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/careers/careers.component.html
// module id = 217
// module chunks = 1